import { render, staticRenderFns } from "./MypageTicketListContainerSection.vue?vue&type=template&id=f94d5924&scoped=true"
import script from "./MypageTicketListContainerSection.vue?vue&type=script&lang=ts"
export * from "./MypageTicketListContainerSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketListContainerSection.vue?vue&type=style&index=0&id=f94d5924&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94d5924",
  null
  
)

export default component.exports